"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _tablePage = _interopRequireDefault(require("_c/CommonForm/table-page"));
var _message = require("_l/message");
var _model = require("_a/flow/model/model");
var _elementUi = require("element-ui");
var _Flowable = _interopRequireDefault(require("@/components/Flowable"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'model-manage',
  components: {
    WorkflowBpmnModeler: _Flowable.default,
    TablePage: _tablePage.default
  },
  data: function data() {
    return {
      queryParams: {},
      columns: [{
        label: '模型ID',
        prop: 'id',
        width: '300px'
      }, {
        label: '名称',
        prop: 'name'
      }, {
        label: '标识',
        prop: 'key'
      }, {
        label: '类别',
        prop: 'category'
      }, {
        label: '版本号',
        prop: 'version',
        width: '80px'
      }, {
        label: '创建时间',
        prop: 'createTime'
      }, {
        label: '更新时间',
        prop: 'lastUpdateTime'
      }, {
        label: '操作',
        slot: 'action'
      }],
      dialogShow: false,
      dialogTitle: '添加模型',
      xml: null,
      modelId: null
    };
  },
  methods: {
    /**
     * 刷新
     */
    refresh: function refresh() {
      this.$refs.tablePage.refresh();
    },
    /**
     * 重置搜索条件
     */
    reset: function reset() {
      this.queryParams = {};
      this.$nextTick(function () {
        this.refresh();
      });
    },
    addModel: function addModel() {
      this.xml = null;
      this.dialogTitle = '添加模型';
      this.dialogShow = true;
    },
    deploy: function deploy(row) {
      var _this = this;
      (0, _message.ConfirmCustom)({
        type: 'warning',
        message: "\u662F\u5426\u786E\u8BA4\u90E8\u7F72\u540D\u79F0\u4E3A\u3010".concat(row.name, "\u3011\u7684\u6A21\u578B?")
      }).then(function () {
        (0, _model.deployModel)(row.id).then(function (res) {
          if (res.data) {
            _elementUi.Message.success({
              message: '部署成功'
            });
          } else {
            _elementUi.Message.error({
              message: '部署失败'
            });
          }
          // 刷新表格
          _this.refresh();
        });
      });
    },
    /**
     * 行内删除
     * @param row
     */
    remove: function remove(row) {
      var _this2 = this;
      (0, _message.ConfirmCustom)({
        type: 'warning',
        message: "\u662F\u5426\u786E\u8BA4\u5220\u9664\u540D\u79F0\u4E3A\u3010".concat(row.name, "\u3011\u7684\u6A21\u578B?")
      }).then(function () {
        (0, _model.deleteModelById)(row.id).then(function (res) {
          if (res.data) {
            _elementUi.Message.success({
              message: '删除成功'
            });
          } else {
            _elementUi.Message.error({
              message: '删除失败'
            });
          }
          // 刷新表格
          _this2.refresh();
        });
      });
    },
    /**
     * 关闭弹出框 和 刷新表格
     */
    cancelDialogAndRefresh: function cancelDialogAndRefresh() {
      this.dialogShow = false;
      // 刷新表格
      this.refresh();
    },
    saveModel: function saveModel(data) {
      var _this3 = this;
      var model = {
        key: data.process.id,
        category: data.process.category,
        name: data.process.name,
        description: data.process.name,
        jsonXml: data.xml,
        svgXml: data.svg
      };
      if (this.dialogTitle === '添加模型') {
        (0, _model.addModel)(model).then(function (res) {
          if (res.data) {
            (0, _message.MessageSuccess)('add');
          } else {
            (0, _message.MessageError)('add');
          }
          _this3.$nextTick(function () {
            // 刷新表格
            this.cancelDialogAndRefresh();
          });
        });
      } else {
        model.id = this.modelId;
        (0, _model.updateModel)(model).then(function (res) {
          if (res.data) {
            (0, _message.MessageSuccess)('upd');
          } else {
            (0, _message.MessageError)('upd');
          }
          _this3.$nextTick(function () {
            // 刷新表格
            this.cancelDialogAndRefresh();
          });
        });
      }
    },
    /**
     * 修改模型
     * @param row
     */
    update: function update(row) {
      var _this4 = this;
      this.modelId = row.id;
      this.dialogTitle = '修改模型';
      this.dialogShow = true;
      (0, _model.getModelJsonById)(row.id).then(function (res) {
        _this4.xml = res.data;
      });
    }
  },
  mounted: function mounted() {}
};